import { type ReactNode } from 'react'

import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'
import { cn } from '@/utils/commonUtil'

import styles from './MenuCommonRoot.module.scss'

type Props = {
  children?: ReactNode
  isOpen?: boolean
  placement?: 'left' | 'right'
  variant?: 'nav' | 'clipboard' | 'filters'
}

export const MenuCommonRoot = ({ children, isOpen, placement = 'left', variant }: Props) => (
  <aside
    className={cn(styles.container, {
      isOpen,
      placement,
      styles,
      variant,
    })}
    {...getClickawayIgnoreProps(['collapse-expanded'])}
  >
    <div className={styles.outer}>
      <div className={styles.inner}>{children}</div>
    </div>
  </aside>
)
